export const EXAM_TYPES = [
  { value: "KTT", label: "Haftalık KTT" },
  { value: "deneme", label: "Deneme" },
];

export default function ExamTypeToggle({ value, onChange, tid = "exam-type-toggle" }) {
  return (
    <div className="inline-flex rounded-full border border-border bg-background p-0.5" data-testid={tid}>
      {EXAM_TYPES.map((t) => {
        const active = value === t.value;
        return (
          <button
            key={t.value}
            type="button"
            onClick={() => onChange(t.value)}
            data-testid={`${tid}-${t.value}`}
            className={`px-3.5 py-1.5 rounded-full text-xs font-semibold transition-colors ${active
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground"}`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
